import { render, staticRenderFns } from "./centerde-follow.vue?vue&type=template&id=76f51a03&scoped=true"
import script from "./centerde-follow.vue?vue&type=script&lang=js"
export * from "./centerde-follow.vue?vue&type=script&lang=js"
import style0 from "./centerde-follow.vue?vue&type=style&index=0&id=76f51a03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f51a03",
  null
  
)

export default component.exports